import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationDocsTab } from '../../requests/getApplicationDocsTab';

export const useApplicationDocsTab = (
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean; refetchOnWindowFocus?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationDocsTab>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'docs-tab', params],
    queryFn: () =>
      getApplicationDocsTab(constructGet, uuid, definitionName, params),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return { docsTab: data, ...rest };
};
